import { createAdminUserActions as e, initialAdminUserState as t } from "./actions/adminUser.action.js";
import { create as i } from "zustand";
var a = i()((r) => ({
  user: t,
  ...e(r)
}));
export {
  a as useAdminStore
};

//# sourceMappingURL=adminStore.js.map